module.exports = __webpack_public_path__ + "51fd96700d087b67aefa79142382c1c2.svg";